/** Inactive nav tab icon stroke; matches CallIconDefault. */
export const NAV_ICON_INACTIVE_STROKE = "#999999";
